module.exports = __webpack_public_path__ + "img/4.e320c0c2.png";